import { render } from "./StatisticRequisites.vue?vue&type=template&id=2fe445a6&ts=true"
import script from "./StatisticRequisites.vue?vue&type=script&lang=ts"
export * from "./StatisticRequisites.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__